import { render, staticRenderFns } from "./ContentCatalog.vue?vue&type=template&id=b15d0a18&scoped=true&"
import script from "./ContentCatalog.vue?vue&type=script&lang=ts&"
export * from "./ContentCatalog.vue?vue&type=script&lang=ts&"
import style0 from "./ContentCatalog.vue?vue&type=style&index=0&id=b15d0a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15d0a18",
  null
  
)

export default component.exports